import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    BOUNCE_ANIMATION_TIME,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotWithBounceCenterTopLeft {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotWithBounceCenterTopLeft',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.TOP_LEFT,
        };
    }

    getAnimationTime() {
        return BOUNCE_ANIMATION_TIME + JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, 3 * Math.PI / 4);

        const firstPartStartXY = startXY;

        if (time < BOUNCE_ANIMATION_TIME) {
            const t = time / BOUNCE_ANIMATION_TIME;
            return {
                x: parabolic(
                    startXY.x, 
                    startXY.x, 
                    firstPartStartXY.x, 
                    t,
                ),
                y: parabolic(
                    startXY.y, 
                    firstPartStartXY.y - distanseBetweenLayers, 
                    firstPartStartXY.y, 
                    t,
                ),
            };
        }

        const t = (time - BOUNCE_ANIMATION_TIME) / JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;

        return {
            x: parabolic(
                firstPartStartXY.x, 
                isLeftMovement ? firstPartStartXY.x - distanceBetweenDots / 2 : firstPartStartXY.x + distanceBetweenDots / 2, 
                endXY.x, 
                t,
            ),
            y: parabolic(
                firstPartStartXY.y, 
                startDot.dotY - distanseBetweenLayers, 
                endXY.y, 
                t,
            ),
        };
    }
}